// import { ImageSourcePropType } from 'react-native'

export const COMMON_IMAGES = {
  backButton: require('./common/backbg.png'),
  supremeGoldLogo: require('./common/logo-gold.png'),
  centerDotBg: require('./common/ludo-dot-bg.png'),
  buttonYellow: require('./common/button-yellow.png'),
  buttonDisabled: require('./common/button-disabled.png'),
  homeBg: require('./common/lobby-bg.png'),
  transparentImage: require('./common/transparentImage.png'),
  loaderImg: require('./common/loader1.webp'),
  camera: require('./common/camera.png'),
  albums: require('./common/albums.png'),
  cross: require('./common/cross.png'),
  calenderIcon: require('./common/calender-icon.png'),
  kycIcon: require('./common/kycDepositIcon.png'),
  kycUploadFailed: require('./common/kycUploadFailed.png'),
  kycUploadSubmitted: require('./common/kycUploadSubmitted.png'),
  kycVerificationSuccessful: require('./common/kycVerificationSuccessful.png'),
  buttonAvoidCta: require('./common/button-hollow-yellow.png'),
  buttonAgreeCta: require('./common/button-yellow-bottomsheet.png'),
  loaderNudgeImg: require('./common/loaderNudgeImg.png'),
  loaderBlackImg: require('./common/loader.png'),
  closeIcon: require('./common/close-icon.png'),
  cardLoader: require('./common/cardLoader.png'),
  ludoBanner: require('./common/ludoBanner.png'),
  errorTriangleRed: require('./common/ExclaimTriangleRed.png'),
  confetti: require('./common/confetti.png'),
  withdrawalSuccessBannerBackground: require('./common/WithdrawalSuccessBannerBackground.png'),
  bannerPlaceholderNew: require('./common/banner-placeholder.png'),
  bannerPlaceholder: 'banner-placeholder',
  mttPlaceholder: 'mtt-placeholder',
  heroPlaceholder: 'hero-home-placeholder',
  nonHeroPlaceholder: 'nonhero-home-placeholder',
  whiteHand: require('./common/white_hand.png'),
  gameJoinKareinHi: require('./common/game_join_karein_hi.png'),
  gameJoinKareinEn: require('./common/game_join_karein_en.png'),
  firstGameEn: require('./common/first_game_en.png'),
  firstGameHi: require('./common/first_game_hi.png')
}

export const REFERRAL_IMAGES = {
  speaker: require('./referral/speaker.png'),
  telegram: require('./referral/telegram.png'),
  wa: require('./referral/wa.png'),
  instagram: require('./referral/instagram.png'),
  share: require('./referral/share.png'),
  fb: require('./referral/fb.png'),
  tg: require('./referral/tg.png')
}

export const GAME_ICONS = {
  snl: require('./gameIcons/snl.png'),
  supreme: require('./gameIcons/supreme.png')
}

export const SHAPES = {
  trapezium: require('./common/YellowTrapezium.png'),
  chalkboard: require('./common/Chalkboard.png')
}

export const VIP = {
  progressBarGoldPng: 'progress_bar_gold',
  goldStatusbar: 'gold_status_bar',
  goldDiamond: 'gold_diamond',
  goldTrapezium: 'gold_trapezium',
  vipScreenBackground: 'vip_screen_background',
  goldMeshBorders: 'gold_mesh_borders'
}

export const ZupeeDefaultIcon = require('./common/ZupeeDefaultIcon.png')

export const GAMEPLAY_HYBRID_IMAGES: { [key: string]: string } = {
  ludoCenterBg: 'ludo-center-bg',
  grWaiting: 'gr_waiting',
  defaultAvatar: 'default-avatar',
  bgTimer: 'bg_timer',
  plcholderGlow: 'plcholder_glow',
  dicePlcholderLeft: 'dice__dice-placeholder-left',
  dicePlcholderRight: 'dice__dice-placeholder-right',
  defaultDiceGreen: 'dice__default-dice-green',
  defaultDiceRed: 'dice__default-dice-red',
  kingDice: require('./gameplay/dice/dice__king-dice.png'),
  dice1: 'dice__dice-1',
  dice2: 'dice__dice-2',
  dice3: 'dice__dice-3',
  dice4: 'dice__dice-4',
  dice5: 'dice__dice-5',
  dice6: 'dice__dice-6',
  destinyYellow: require('./gameplay/yellow@3x.png'),
  destinyRed: 'destiny__red',
  destinyGreen: 'destiny__green',
  bgGameplayPrizepot: 'bg_gameplay_pricepot',
  bgGameplayTopMessage: 'bg_gameplay_top_message',
  icClock: 'ic_clock',
  infoIcon: 'info_icon',
  bgGameplayStartText: 'bg_gameplay_start_text',
  cross: 'cross',
  user_stats: 'user_stats',
  gr_prize_small: 'gr_prize_small',
  gr_thumb_small: 'gr_thumb_small',
  ic_common: 'ic_common',
  prizeDistrubutionBg: 'prizeDistrubution-bg',
  leftTag: 'left_tag',
  chalaGayaTag: 'chalagaya_tag',
  result_winner: 'crown',
  result_rank: 'medal',
  result_tie: 'tie',
  result_looser: 'dice_saturn',
  bgScoreGlow: 'bg_score_glow',
  path3Player: 'path_3_player',
  pathBorder3Player: 'path_border_3_player',
  pathBg3Player: 'path_bg_3_player',
  prizeDistributionIcon: 'prize_distribution_icon',
  blue_sunburst: 'blue_sunburst',
  blue_sunburst_2p4p: 'blue_sunburst_2p4p',
  stable_internet: 'stable_internet',
  weak_internet: 'weak_internet',
  no_internet: 'no_internet',
  board_2_4_player: 'board_2_4_player',
  prizePoolTrophy: 'prize_pool_trophy',
  dice_default: 'ic_dice_default',
  dice2P_1: require('./gameplay/dice/dice2P_1.png'),
  dice2P_2: require('./gameplay/dice/dice2P_2.png'),
  dice2P_3: require('./gameplay/dice/dice2P_3.png'),
  dice2P_4: require('./gameplay/dice/dice2P_4.png'),
  dice2P_5: require('./gameplay/dice/dice2P_5.png'),
  dice2P_6: require('./gameplay/dice/dice2P_6.png'),
  crossNewDesign: 'cross_new_design',
  thumbsDown: 'thumbs_down',
  tokenGraphics: 'token_graphics',
  ludoboardCenterNudge: 'ludoboard_center_nudge',
  clockNewNormal: 'clock_new_normal',
  winnerCrown: 'winner_crown',
  winnerScreenBackground: 'winnerscreen_bg',
  winnerScreenPrizeDistribution: 'winnerscreen_prize_distribution',
  winnerScreenLoose: 'winnerScreen_loose',
  winnerScreenTie: 'winnerScreen_tie',
  winnerScreenCoin: 'winnerScreen_coin',
  handPointing: 'hand_pointing',
  handPointingLudonx: 'hand_pointing_ludonx',
  nudgeGradientBackground: 'nudge_gradient_background',
  gameplayHorizontalNudge: 'gameplay_horizontal_nudge',
  lb24SkipBg: 'lb_2_4_skip_bg',
  shutterstock: 'shutterstock',
  winnerScreenTokenClash: 'winnerScreen_tokenClash',
  nxBgPattern: 'nx_bg_pattern',
  ludonxThumbsUp: 'winnerscreen_ludonx_thumbsUp',
  ludonxSunburstAndStars: 'winnerscreen_ludonx_sunburstAndStars',
  ludonxMoneyBag: 'winnerscreen_ludonx_moneyBag',
  ludonxClock: 'winnerscreen_ludonx_clock'
}

export const PAW_IMAGES = {
  bg_paw_youWon: 'bg_paw_youWon',
  paw_header_placeholder: 'paw_header_placeholder'
}

type ImageSourcePropType = string;

export const GAMEPLAY_ANIMATION_IMAGES: { [key: string]: ImageSourcePropType } = {
  diceLoader: require('../../assets/gifs/dice_animation.gif') as ImageSourcePropType,
  smokeYellow: require('./gameplay/smoke/yellow.png') as ImageSourcePropType,
  smokeBlue: require('./gameplay/smoke/blue.png') as ImageSourcePropType,
  smokeRed: require('./gameplay/smoke/red.png') as ImageSourcePropType,
  smokeGreen: require('./gameplay/smoke/green.png') as ImageSourcePropType,
  figurineYellow: require('./gameplay/figurine/yellow.png') as ImageSourcePropType,
  figurineRed: require('./gameplay/figurine/red.png') as ImageSourcePropType,
  figurineGreen: require('./gameplay/figurine/green.png') as ImageSourcePropType,
  glowYellow: require('./gameplay/movingKukariGlow/yellow.png') as ImageSourcePropType,
  glowBlue: require('./gameplay/movingKukariGlow/blue.png') as ImageSourcePropType,
  glowRed: require('./gameplay/movingKukariGlow/red.png') as ImageSourcePropType,
  glowGreen: require('./gameplay/movingKukariGlow/green.png') as ImageSourcePropType,
  diceGlow: require('./gameplay/dice_glow.png') as ImageSourcePropType,
  startEn: require('./gameplay/start_en.png') as ImageSourcePropType,
  startHi: require('./gameplay/start_hi.png') as ImageSourcePropType,
  skipEn: require('./gameplay/skip_en.png') as ImageSourcePropType,
  skipHi: require('./gameplay/skip_hi.png') as ImageSourcePropType,
  coin: require('./gameplay/coin.png') as ImageSourcePropType,
  hand: require('./gameplay/hand.png') as ImageSourcePropType,
  figurine_2_4__blue: require('./gameplay/figurine_2_4_player/blue.png') as ImageSourcePropType,
  figurine_2_4__green: require('./gameplay/figurine_2_4_player/green.png') as ImageSourcePropType,
  figurine_2_4__red: require('./gameplay/figurine_2_4_player/red.png') as ImageSourcePropType,
  figurine_2_4__yellow: require('./gameplay/figurine_2_4_player/yellow.png') as ImageSourcePropType,
  gameplayCenterNudge: require('./gameplay/ludoboard_center_nudge.png') as ImageSourcePropType,
  lbBgStartNudge: require('./gameplay/lb_bg_start_nudge.png') as ImageSourcePropType,
  lbNudgeBgEclipse: require('./gameplay/lb_nudge_bg_eclipse.png') as ImageSourcePropType,
  lbNudgeBgDarkCircle: require('./gameplay/lb_nudge_bg_dark_circle.png') as ImageSourcePropType,
  startNew: require('./gameplay/start_new.png') as ImageSourcePropType,
  turnSkipNew: require('./gameplay/turn_skip_new.png') as ImageSourcePropType,
  lbStartThumbsUp: require('./gameplay/lb_start_thumbs_up.png') as ImageSourcePropType,
  lbSkipTripleSix: require('./gameplay/lb_skip_triple_six.png') as ImageSourcePropType,
  red_56: require('./gameplay/home/red_56.png') as ImageSourcePropType,
  blue_56: require('./gameplay/home/blue_56.png') as ImageSourcePropType,
  green_56: require('./gameplay/home/green_56.png') as ImageSourcePropType,
  crosshair: require('./gameplay/crosshair.png') as ImageSourcePropType,
  safeHighlightRays: require('./gameplay/safeHighlightRays.png') as ImageSourcePropType,
  homeHighlightBox: require('./gameplay/homeHighlightBox.png') as ImageSourcePropType,
  homeHighlightTriangle: require('./gameplay/homeHighlightTriangle.png') as ImageSourcePropType,
  red_43_en: require('./gameplay/home/red_43_en.png') as ImageSourcePropType,
  green_43_en: require('./gameplay/home/green_43_en.png') as ImageSourcePropType,
  red_43_hi: require('./gameplay/home/red_43_hi.png') as ImageSourcePropType,
  green_43_hi: require('./gameplay/home/green_43_hi.png') as ImageSourcePropType
}
